import router from "../../router";
import IbonazzService from "@/services/ibonazz-service";


/*** Products */
export function loadTypeList({ commit }) {
    IbonazzService.getTypeList().then(response => {
        commit("_setTypeListArray", response.data);
    })
    .catch(e => {
        console.log(e);
    });
}
